import { ArrowsClockwiseIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/ui';

import styles from './StaleNotice.module.css';

interface StaleNoticeProps {
  /** Пересчёт уже готов: можно показать новый список. */
  refreshReady: boolean;
  onShowRefreshed: () => void;
}

/**
 * Баннер «данные обновляются» (MATCHING §10, MVP_TECH_RFC §22).
 *
 * Каталог изменился, и прогон помечен `stale`. Старые результаты остаются на
 * экране: подменять список молча нельзя — пользователь потерял бы то, что
 * только что читал. Переключение на пересчёт делает он сам, кнопкой.
 */
export function StaleNotice({ refreshReady, onShowRefreshed }: StaleNoticeProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.notice} role="status">
      <ArrowsClockwiseIcon size={18} weight="bold" aria-hidden="true" />
      <p className={styles.text}>
        {refreshReady ? t('results.stale.ready') : t('results.stale.updating')}
      </p>
      {refreshReady ? (
        <Button variant="secondary" size="md" onClick={onShowRefreshed}>
          {t('results.stale.show')}
        </Button>
      ) : null}
    </div>
  );
}
